import { render, staticRenderFns } from "./ShopStaffsWindow.vue?vue&type=template&id=38abddd5&scoped=true"
import script from "./ShopStaffsWindow.vue?vue&type=script&lang=js"
export * from "./ShopStaffsWindow.vue?vue&type=script&lang=js"
import style0 from "./ShopStaffsWindow.vue?vue&type=style&index=0&id=38abddd5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38abddd5",
  null
  
)

export default component.exports